import { faArrowRightFromBracket } from "@fortawesome/pro-solid-svg-icons"
import { AccountDetails } from "../components/Account/AccountDetails"
import HeroButton from "../components/common/HeroButton"
import HeroButtonsContainer from "../components/common/HeroButtonsContainer"
import HeroContainer from "../components/common/HeroContainer"
import { useSignOutMutation } from "../components/authentication/authenticationQueries"
import { AuthenticationContext } from "../AuthenticationContext"
import { useContext } from "react"

const TOKEN_NAME = 'synkedup_token'

const AccountPage = () => {
  const { currentUser } = useContext(AuthenticationContext)
  const signOutMutation = useSignOutMutation()

  if (!currentUser) {
    return <></>
  }

  const heroImageUrl = `${currentUser.coverImage}/images/default-projects.jpg`

  const handleLogout = () => {
    signOutMutation.mutate()
    localStorage.removeItem(TOKEN_NAME)
    window.Intercom('shutdown');
    window.location.href = "/#!/account";
    window.location.reload();
  }

  return <>
    <HeroContainer imgSrc={heroImageUrl} />
    <div className="hero-details">
      <h1>Your Account</h1>
      <HeroButtonsContainer>
        <HeroButton icon={faArrowRightFromBracket} onClick={handleLogout} />
      </HeroButtonsContainer>
    </div>

    <AccountDetails account={currentUser} />
  </>
}

export default AccountPage
